export const TAG_SOURCE = [
    {
        key: 'litterati',
        label: 'Litterati',
        id: 'litterati',
    },
    {
        key: 'user',
        label: 'User Generated',
        id: 'userGenerated',
    },
];

export const STANDARDS = [
    {
        key: 'litterati',
        label: 'Litterati',
        id: 'litterati',
    },
    {
        key: 'ospar',
        label: 'Ospar',
        id: 'ospar',
    },
    {
        key: 'noaa',
        label: 'Noaa',
        id: 'noaa',
    },
    {
        key: 'csiro',
        label: 'Csiro',
        id: 'csiro',
    },
    {
        key: 'bffp',
        label: 'Bffp',
        id: 'bffp',
    },
];

export const SHOW_UNIT = [
    {
        key: 'no_of_pieces',
        label: '# of Pieces',
        id: 'no_of_pieces',
    },
    {
        key: 'volume',
        label: 'Volume',
        id: 'volume',
    },
    {
        key: 'weight',
        label: 'Weight',
        id: 'weight',
    },
];
